// Core

// Chakra
import {
  Box, Code, Table, Tbody, Td,
  Text, Thead, Tr,
} from '@chakra-ui/react';

// Components
import {
  GiveawaysActiveIcon,
} from 'components/Icons/Icons';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import Card from 'components/Card/Card';
import ErrorCard from 'components/Errors';
import { parseDateTime } from '../../../../services/Utils';
import UserPurchasesStats from './UserPurchasesStats';


const dateFields = ['purchasedAt', 'createdAt'];

const userPurchaseFields = [
  { key: 'id', label: 'ID' },
  { key: 'userCid', label: 'User External ID' },
  { key: 'txId', label: 'Transaction ID' },
  { key: 'type', label: 'Purchase Type' },
  { key: 'quantity', label: 'Quantity' },
  { key: 'unitPrice', label: 'Unit Price' },
  { key: 'grossAmount', label: 'Gross Amount' },
  { key: 'discountAmount', label: 'Discount Amount' },
  { key: 'netAmount', label: 'Net Amount' },
  { key: 'purchasedAt', label: 'Purchased At' },
  { key: 'createdAt', label: 'Created At' },
];

const formatValue = (key, value) => {
  if (!value) {return '';}

  if (dateFields.includes(key)) {
    return parseDateTime(value);
  }

  return String(value);
};

const UserPurchasesDetailsContent = ({ posTransaction, errorCard }) => {

  return (
    <Box
      zIndex="9"
      position="relative"
    >
      <Breadcrumbs
        icon={GiveawaysActiveIcon}
        target="User Purchases"
        url="#/user-purchases"
        current="User Purchase"
        variant="standart"
      />

      {errorCard && <ErrorCard error={errorCard} maxW="840px" />}

      {posTransaction?.userCid && (<UserPurchasesStats userCid={posTransaction?.userCid} />)}


      <Box maxW="840px">

        <Text variant="title-lg" mt="40px" mb="14px">
          User Purchase Details
        </Text>

        <Card padding="24px" mb="40px">

          <Table>
            <Tbody>
              {userPurchaseFields.map(({ key, label }) => (
                <Tr key={key}>
                  <Td verticalAlign="top" border="unset">
                    <Text variant="title">{label}</Text>
                  </Td>
                  <Td verticalAlign="top" border="unset">
                    {formatValue(key, posTransaction?.[key])}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Card>

        <Text variant="title-lg" mt="40px" mb="14px">
          Transaction
        </Text>

        <Card padding="24px" mb="40px">
          <Code
              p={4}
              w="100%"
              mt="24px"
              whiteSpace="pre"
              overflowX="auto"
              colorScheme="gray"
          >
            {JSON.stringify(posTransaction?.tx, null, 2)}
          </Code>
        </Card>

        <Text variant="title-lg" mt="40px" mb="14px">
          User
        </Text>

        <Card padding="24px" mb="40px">
          <Code
              p={4}
              w="100%"
              mt="24px"
              whiteSpace="pre"
              overflowX="auto"
              colorScheme="gray"
          >
            {JSON.stringify(posTransaction?.user, null, 2)}
          </Code>
        </Card>

      </Box>

    </Box>
  );
};

export default UserPurchasesDetailsContent;
